import regeneratorRuntime from "/app/node_modules/.pnpm/regenerator-runtime@0.13.4/node_modules/regenerator-runtime/runtime.js";
import { NAMESPACE } from 'portal-common/constants/requestConstants';
import { api } from 'portal-common/http';
import { GET_USER_INFO_URL } from '../common/constants';
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
// 获取用户信息，带校验登录态作用
export var getUserInfo = _asyncToGenerator(regeneratorRuntime.mark(function _callee(req) {
    var ref, ref1, ref2, ref3, result;
    return regeneratorRuntime.wrap(function _callee$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                ;
                _ctx.next = 3;
                return api.call(GET_USER_INFO_URL, {
                    method: 'get',
                    params: {
                        uin: (req === null || req === void 0 ? void 0 : (ref = req.cookies) === null || ref === void 0 ? void 0 : ref.uin) || '',
                        skey: (req === null || req === void 0 ? void 0 : (ref1 = req.cookies) === null || ref1 === void 0 ? void 0 : ref1.skey) || ''
                    },
                    headerconfig: {
                        Cookie: "uin=".concat((req === null || req === void 0 ? void 0 : (ref2 = req.cookies) === null || ref2 === void 0 ? void 0 : ref2.uin) || '', ";skey=").concat((req === null || req === void 0 ? void 0 : (ref3 = req.cookies) === null || ref3 === void 0 ? void 0 : ref3.skey) || '')
                    }
                });
            case 3:
                result = _ctx.sent;
                return _ctx.abrupt("return", result);
            case 5:
            case "end":
                return _ctx.stop();
        }
    }, _callee);
}));
/** *
*@description 根据活动资源查询表单资源
*@param {
"eventId":"E2008102031",
"ecId":"EC20012398002"
},
 * */ export var queryFormInfo = _asyncToGenerator(regeneratorRuntime.mark(function _callee(params) {
    var API_PREFIX, result;
    return regeneratorRuntime.wrap(function _callee$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                API_PREFIX = "/".concat(NAMESPACE.QCINTL_API);
                _ctx.next = 3;
                return api.fetchMidProxy("".concat(API_PREFIX, "/portal-operation-event/queryFormInfo"), {
                    body: params,
                    method: 'post'
                });
            case 3:
                result = _ctx.sent;
                return _ctx.abrupt("return", result);
            case 5:
            case "end":
                return _ctx.stop();
        }
    }, _callee);
}));
